import { render, staticRenderFns } from "./BaseInputRadio.vue?vue&type=template&id=3fed64d2&scoped=true&"
import script from "./BaseInputRadio.vue?vue&type=script&lang=ts&"
export * from "./BaseInputRadio.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputRadio.vue?vue&type=style&index=0&id=3fed64d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed64d2",
  null
  
)

export default component.exports